export const SDK_VERSION = '7.85.0';
